var map = {
	"./Art.json": "ec91",
	"./Farming.json": "8788",
	"./Financial.json": "ffb9",
	"./Food.json": "2ea0",
	"./Home.json": "696e7",
	"./Hotel.json": "9418",
	"./Legal.json": "9620",
	"./Logistics.json": "e02d",
	"./Manufacturing.json": "08f1",
	"./Medical.json": "3e9b",
	"./StockFarming.json": "3701",
	"./Ticket.json": "291d",
	"./Trad.json": "2764",
	"./Transport.json": "4b23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d27";